import React, { Suspense, createContext, useContext, useEffect, useMemo, useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import BackButtonComponent from '../../../CommonComponent/BackButtonComponent';
import LoadingComponent from '../../../CommonComponent/LoadingComponent';
import { useCustomerStore } from '../../../../stores/CustomerStore';
import { useManualWaybillChargesStore } from '../../../../stores/ManualWaybillChargesStore';
import { CountryEnum, isAccessible } from '../../../../utils/app-common';
import { PRICING_TEAM_ACCESS } from '../../../../utils/access-list';

export const EXPRESS_PRODUCT_KG_UNIT_ID = 1;

interface ManualWaybillChargesContextValue {
    readOnly: boolean;
    selectedProductId?: number;
    setSelectedProductId: (id?: number) => void;
    isExpressProduct: boolean;
}

const ManualWaybillChargesContext = createContext<ManualWaybillChargesContextValue>({
    readOnly: false,
    setSelectedProductId: () => { },
    isExpressProduct: false,
});

export const useManualWaybillChargesCtx = () => useContext(ManualWaybillChargesContext);

const StationsTabComponentLoadable = React.lazy(() => import('./StationsTabComponent'));

interface Props {
    readOnly?: boolean;
    onBack?: () => void;
}

const ManualWaybillChargesComponent = ({ onBack }: Props) => {
    const GetAgreementMasterListAction = useCustomerStore((state) => state.GetAgreementMasterListAction);
    const GetActiveProductListAction = useManualWaybillChargesStore((state) => state.GetActiveProductListAction);
    const ResetManualWaybillChargesStoreAction = useManualWaybillChargesStore((state) => state.ResetManualWaybillChargesStoreAction);
    const activeProductList = useManualWaybillChargesStore((state) => state.activeProductList);

    const readOnly = !isAccessible(PRICING_TEAM_ACCESS, [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true);

    const [selectedProductId, setSelectedProductId] = useState<number>();

    const isExpressProduct = useMemo(
        () => !!activeProductList.find((p) => p.id === selectedProductId)?.name?.toLocaleLowerCase().includes('express'),
        [activeProductList, selectedProductId]
    );

    useEffect(() => {
        trackPromise(GetAgreementMasterListAction(), 'master-list-area');
        trackPromise(GetActiveProductListAction(), 'master-list-area');

        return () => {
            ResetManualWaybillChargesStoreAction();
        };
    }, [GetAgreementMasterListAction, GetActiveProductListAction, ResetManualWaybillChargesStoreAction]);

    return (
        <ManualWaybillChargesContext.Provider value={{ readOnly, selectedProductId, setSelectedProductId, isExpressProduct }}>
            <div>
                <BackButtonComponent onClick={onBack} />
                <Suspense fallback={<LoadingComponent />}>
                    <StationsTabComponentLoadable />
                </Suspense>
            </div>
        </ManualWaybillChargesContext.Provider>
    );
};

export default ManualWaybillChargesComponent;
